import React, { useContext, useEffect, useLayoutEffect, useState, useRef, useCallback } from 'react';
import { Dropdown, Layout, Menu, Button, Badge, Avatar, Drawer, Tooltip, Card, Tag, Spin, Switch, message, Modal, notification } from 'antd';
import {
	MenuFoldOutlined,
	MenuUnfoldOutlined,
	DashboardOutlined,
	SafetyCertificateOutlined,
	ProjectOutlined,
	ApartmentOutlined,
	TeamOutlined,
	BellOutlined,
	CrownOutlined,
	FundOutlined,
	LogoutOutlined,
	ToolOutlined,
	AuditOutlined,
	MailOutlined,
	FileDoneOutlined,
	AimOutlined,
	SearchOutlined,
	BugOutlined,
	ShopOutlined,
	SignatureOutlined,
	CheckCircleTwoTone, CloseCircleTwoTone,
	ShoppingCartOutlined,
	BookOutlined,
	CheckCircleFilled,
	WalletOutlined,
	TransactionOutlined,
	CarOutlined,
	ExclamationCircleOutlined,
	CloseOutlined,
	ReloadOutlined,
	PartitionOutlined,
	LaptopOutlined
} from '@ant-design/icons';

import { Routes, Route, Navigate, useNavigate, useLocation, Link } from 'react-router-dom';
import './App.css';
import { useAuth } from './Context/AuthContext';

import Team from './Pages/Team/Team';
import DomainMapping from './Pages/DomainMapping/DomainMapping';
import Scheduler from './Pages/Scheduler/Scheduler';
import Login from './Pages/Login/Login';
import Analytics from './Pages/Analytics/Analytics';
import Dashboard from './Pages/Dashboard/Dashboard';
import { ROUTES } from './Routes/Routes';
import LeadNotification from './Components/LeadNotification/LeadNotification';
import EmailInbox from './Pages/EmailInbox/EmailInbox';
import ZohoSign from './Pages/ZohoSign/ZohoSign';
import ZohoSignComplete from './Pages/ZohoSignComplete/ZohoSignComplete';

import MyFollowUps from './Pages/MyFollowUps/MyFollowUps';
import IndividulFollowUpLead from './Pages/IndividulFollowUpLead/IndividulFollowUpLead';
import MyLeads from './Pages/MyLeads/MyLeads';
import MarketingLeads from './Pages/MarketingLeads/MarketingLeads';
import ErrorLeads from './Pages/ErrorLead/ErrorLead';
import ReviewLeads from './Pages/ReviewLeads/ReviewLeads';
import AccountSessions from './Pages/AccountSessions/AccountSessions';
import LeadDetails from './Pages/LeadDetails/LeadDetails';
import API from './API/API';
import axios from 'axios';
const { Header, Sider, Content } = Layout;
import Config from './API/Config';
import PaymentPending from './Pages/PaymentPending/PaymentPending';
import AllLeads from './Pages/AllLeads/AllLeads';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import NoteList from './Pages/Notes/NoteList ';
import Customer from './Pages/Customer/Customer';
import CustomerDetails from './Pages/Customer/CustomerDetails';
import QueueDashboard from './Components/QueueDashboard/QueueDashboard';
import AllLeadsView from './Pages/MyLeads/AllLeadsView';
import Notification from './Pages/Notifaction/Notifaction';
import ViewyardDetails from './Pages/Yard_pages/Viewyard';
import YardDetailsPage from './Pages/Yard_pages/YardDetailsPage';
import SaleMadeLead from './Pages/SaleMadeLead/SaleMadeLead';
import io from 'socket.io-client';
import IdleLogout from './Components/IdleLogout/IdleLogout';
import IssueTracking from './Pages/IssueTracking/IssueTracking';
import PendingPayment from './Pages/PendingPayment/PendingPayment.jsx';
import AdvancePayment from './Pages/AdvancePayment/AdvancePayment.jsx';
import OrderPending from './Pages/OrderPending/OrderPending.jsx';
import OrderComplete from './Pages/OrderComplete/OrderComplete.jsx';
import Invoice from './Pages/Invoice/Invoice.jsx';
import DisputeLead from './Pages/DisputeLead/DisputeLead.jsx';

import ShipmentTracking from './Pages/ShipmentTracking/ShipmentTracking.jsx';

import ShipmentTrackingComplete from './Pages/ShipmentTrackingComplete/ShipmentTrackingComplete.jsx';
import YardRefund from './Pages/YardRefund/YardRefund.jsx';
import CustomerRfund from './Pages/CustomerRfund/CustomerRfund.jsx';
import YardRefundCompleted from './Pages/YardRefundCompleted/YardRefundCompleted.jsx';
import CustomerRfundCompleted from './Pages/CustomerRfundCompleted/CustomerRfundCompleted.jsx';

import SaleMadeComplete from './Pages/SaleMadeComplete/SaleMadeComplete.jsx';
import CustomerCancel from './Pages/CustomerCancel/CustomerCancel.jsx';
import ReLocate from './Pages/ReLocate/ReLocate.jsx';


import RRVisualizationDashboard from './Components/RoundRobin/RRVisualizationDashboard';
import TimezoneBanner from './Components/TimezoneBanner/TimezoneBanner';
import { BadgeDollarSign, CircleX, ShoppingBag, ShoppingBasket, Undo2 } from 'lucide-react';

// Lazy so the static help page stays out of the main bundle
const FlowDiagram = React.lazy(() => import('./Pages/FlowDiagram/FlowDiagram.jsx'));

dayjs.extend(utc);
dayjs.extend(timezone);

const ADVANCE_PAYMENT_ALLOWED_ROLES = ['ADMIN', 'SERVICE-AGENT', 'SALES-AGENT'];

const canAccessAdvancePayment = (role) => ADVANCE_PAYMENT_ALLOWED_ROLES.includes(role);

const FLOW_DIAGRAM_ALLOWED_ROLES = ['ADMIN', 'SERVICE-AGENT'];

const canAccessFlowDiagram = (role) => FLOW_DIAGRAM_ALLOWED_ROLES.includes(role);

// MARKETING: read-only login that sees only the My Leads page (Marketing Leads view).
const MARKETING_ROLE = 'MARKETING';
const MARKETING_MENU_KEYS = ['/my-leads'];

const getStoredUserData = () => {
	try {
		return JSON.parse(localStorage.getItem('userData') || '{}');
	} catch (error) {
		return {};
	}
};

// Add this interceptor setup function
const setupAxiosInterceptors = (logout, navigate) => {
	axios.interceptors.response.use(
		(response) => response,
		(error) => {
			if (error.response?.status === 401 || error.response?.status === 403) {
				// Clear storage
				localStorage.removeItem('token');
				localStorage.removeItem('userData');
				localStorage.removeItem('sidebarFrom');

				// Call logout from auth context
				logout();

				// Navigate to login
				navigate(ROUTES.LOGIN, { replace: true });
			}
			return Promise.reject(error);
		}
	);
};

const App = () => {
	const { userData, logout, isAuthenticated: authIsAuthenticated } = useAuth();
	const navigate = useNavigate();
	const location = useLocation();
	const [isAuthenticated, setIsAuthenticated] = useState(null);
	const [loading, setLoading] = useState(true);
	const rcInitialized = useRef(false);
	const abortControllerRef = useRef(null);
	const navigationInProgress = useRef(false);
	const interceptorsSet = useRef(false);

	// Set up axios interceptors once
	useEffect(() => {
		if (!interceptorsSet.current) {
			setupAxiosInterceptors(logout, navigate);
			interceptorsSet.current = true;
		}
	}, [logout, navigate]);

	// Single source of truth for auth state
	useEffect(() => {
		const checkAuth = () => {
			const token = localStorage.getItem('token');
			const userData = localStorage.getItem('userData');
			const hasAuth = !!token && !!userData;

			// Sync with auth context
			setIsAuthenticated(hasAuth);
			setLoading(false);
		};

		checkAuth();

		// Listen for storage changes (in case of logout in another tab)
		const handleStorageChange = (e) => {
			if (e.key === 'token' || e.key === 'userData') {
				checkAuth();
			}
		};

		window.addEventListener('storage', handleStorageChange);
		return () => window.removeEventListener('storage', handleStorageChange);
	}, []);

	// Handle navigation with cleanup
	// useEffect(() => {
	//    if (!loading && !navigationInProgress.current) {
	//       const isLoginPage = location.pathname === ROUTES.LOGIN;

	//       if (!isAuthenticated && !isLoginPage) {
	//          navigationInProgress.current = true;

	//          // Cancel any pending requests
	//          if (abortControllerRef.current) {
	//             abortControllerRef.current.abort();
	//          }

	//          // Navigate to login with replace to prevent history stack issues
	//          navigate(ROUTES.LOGIN, { replace: true });

	//          // Reset navigation flag after a short delay
	//          setTimeout(() => {
	//             navigationInProgress.current = false;
	//          }, 100);
	//       } else if (isAuthenticated && isLoginPage) {
	//          navigationInProgress.current = true;
	//          navigate(ROUTES.MYLEADS, { replace: true });

	//          setTimeout(() => {
	//             navigationInProgress.current = false;
	//          }, 100);
	//       }
	//    }
	// }, [isAuthenticated, loading, location.pathname, navigate]);

	// RingCentral initialization only when authenticated
	// useEffect(() => {
	//    // Don't initialize if not authenticated
	//    if (!isAuthenticated) {
	//       if (window.RCAdapter) {
	//          window.RCAdapter.setMinimized(true);
	//       }
	//       return;
	//    }

	//    // Only initialize once
	//    if (!window.RCAdapter && !rcInitialized.current) {
	//       const rcs = document.createElement("script");
	//       rcs.src = "https://apps.ringcentral.com/integration/ringcentral-embeddable/latest/adapter.js";
	//       rcs.async = true;
	//       document.head.appendChild(rcs);

	//       rcs.onload = () => {
	//          if (window.RCAdapter) {
	//             window.RCAdapter.init({
	//                appServer: "production",
	//                clientId: "0QQE1mFbjlyboRCq621mUn",
	//                redirectUri: `${Config.baseURL}/my-leads/`,
	//                disableMessages: false,
	//                disableCall: false,
	//                disableContacts: false,
	//                disableMeeting: false,
	//                disableGlip: true,
	//                disableMinimize: false,
	//                enablePopup: true,
	//                enableRingtoneSettings: true,
	//                enableSMSTemplate: false,
	//                enableAnalytics: true,
	//                enableNoiseReductionSetting: true,
	//                multipleTabsSupport: true,
	//                newAdapterUI: true,
	//                defaultDirection: "right",
	//                enableLoadMoreCalls: true,
	//                enableAudioInitPrompt: true,
	//             });
	//             window.RCAdapter.setMinimized(true);
	//             rcInitialized.current = true;
	//          } else {
	//             console.error("❌ RCAdapter is undefined after script load!");
	//          }
	//       };
	//    }
	// }, [isAuthenticated]);

	// Loading state
	if (loading || isAuthenticated === null) {
		return (
			<Layout style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
				<Spin size="large" />
			</Layout>
		);
	}

	return (
		<div>
			<Routes>
				<Route
					path={ROUTES.LOGIN}
					element={isAuthenticated ? <Navigate to={ROUTES.MYLEADS} replace /> : <Login onLogin={() => setIsAuthenticated(true)} />}
				/>
				<Route
					path="/*"
					element={isAuthenticated ? <MainLayout key={isAuthenticated ? 'authenticated' : 'unauthenticated'} /> : <Navigate to={ROUTES.LOGIN} replace />}
				/>
			</Routes>
		</div>
	);
};

const MainLayout = () => {
	const navigate = useNavigate();
	const location = useLocation();
	const { logout, userData: authUserData } = useAuth();
	const [collapsed, setCollapsed] = useState(false);
	const [userDetails, setUserDetails] = useState({});
	const [toggleLoading, setToggleLoading] = useState(false);
	const socketRef = useRef(null);
	const toggleInProgress = useRef(false);
	const [leads, setLeads] = useState([]);
	const activeFollowUpNotifications = useRef(new Set()).current;
	const [initialLoadComplete, setInitialLoadComplete] = useState(false);
	const isMounted = useRef(true);
	const abortControllerRef = useRef(null);
	const dataLoadedRef = useRef(false);
	const socketEventHandlersRef = useRef({
		accountStatusUpdated: null,
		forceLogout: null,
		leadAssigned: null
	});

	// Helper function to update user details in both state and localStorage
	const updateUserDetails = useCallback((updates) => {
		setUserDetails(prev => {
			const updated = { ...prev, ...updates };
			// Update localStorage immediately
			localStorage.setItem('userData', JSON.stringify(updated));
			return updated;
		});
	}, []);

	// Cleanup on unmount
	useEffect(() => {
		isMounted.current = true;
		abortControllerRef.current = new AbortController();

		return () => {
			isMounted.current = false;
			if (abortControllerRef.current) {
				abortControllerRef.current.abort();
			}

			// Safely disconnect socket
			if (socketRef.current) {
				// Remove all event listeners before disconnecting
				if (socketEventHandlersRef.current.accountStatusUpdated) {
					socketRef.current.off("account-status-updated", socketEventHandlersRef.current.accountStatusUpdated);
				}
				if (socketEventHandlersRef.current.forceLogout) {
					socketRef.current.off("forceLogout", socketEventHandlersRef.current.forceLogout);
				}
				if (socketEventHandlersRef.current.leadAssigned) {
					socketRef.current.off("lead-assigned", socketEventHandlersRef.current.leadAssigned);
				}
				socketRef.current.off("connect");

				socketRef.current.disconnect();
				socketRef.current = null;
			}
		};
	}, []);

	// ✅ Derive isActive from userDetails (single source of truth)
	const isActive = userDetails?.isActive || false;

	// Initialize socket connection with auth token - only if authenticated
	useEffect(() => {
		const token = localStorage.getItem('token');
		if (!token || !isMounted.current) return;

		socketRef.current = io(Config.baseURL, {
			transports: ["websocket"],
			withCredentials: true,
			auth: { token }
		});

		return () => {
			// This cleanup will be called on dependency change or unmount
			// But we handle the main cleanup in the main unmount effect
		};
	}, []);

	// ✅ Handle socket reconnection - rejoin room
	useEffect(() => {
		if (!socketRef.current || !userDetails?.id || !isMounted.current) return;

		const handleConnect = () => {
			if (!isMounted.current || !socketRef.current) return;
			console.log('Socket reconnected - rejoining room');
			socketRef.current.emit("register-agent", userDetails.id);
		};

		socketRef.current.on("connect", handleConnect);

		return () => {
			if (socketRef.current) {
				socketRef.current.off("connect", handleConnect);
			}
		};
	}, [userDetails?.id]);

	// Load user data from single source
	useEffect(() => {
		const loadUserData = async () => {
			// Prevent multiple loads
			if (dataLoadedRef.current) return;

			// Check if component is still mounted and authenticated
			if (!isMounted.current) return;

			const token = localStorage.getItem('token');
			if (!token) {
				setInitialLoadComplete(true);
				return;
			}

			try {
				// First try localStorage for immediate UI
				const storedUser = localStorage.getItem('userData');
				if (storedUser && isMounted.current) {
					try {
						const localUser = JSON.parse(storedUser);
						setUserDetails(localUser);
					} catch (e) {
						console.error('Error parsing stored user data:', e);
					}
				}

				// Then fetch fresh data from API with abort controller
				const response = await API.getCurrentUser({
					signal: abortControllerRef.current?.signal
				});

				if (!isMounted.current) return;

				if (response?.success && response.user) {
					const user = response.user;
					updateUserDetails(user);

					// ✅ Join socket room with correct event name
					if (socketRef.current && user.id) {
						socketRef.current.emit("register-agent", user.id);
					}

					dataLoadedRef.current = true;
				}
			} catch (error) {
				if (!isMounted.current) return;

				// Handle 401/403 errors - axios interceptor will handle this
				if (error.response?.status === 401 || error.response?.status === 403) {
					console.log('Authentication error');
					return;
				}

				console.error('Failed to load user data:', error);
			} finally {
				if (isMounted.current) {
					setInitialLoadComplete(true);
				}
			}
		};

		loadUserData();
	}, [updateUserDetails]);

	// ✅ CRITICAL FIX: Listen for 'account-status-updated' (matches backend)
	useEffect(() => {
		if (!socketRef.current || !userDetails?.id || !isMounted.current) return;

		const agentId = String(userDetails.id);

		// ✅ Listen for EXACT event name backend emits: 'account-status-updated'
		const handleAccountStatusUpdated = (data) => {
			if (!isMounted.current) return;

			console.log('🔵 ACCOUNT STATUS UPDATED ==========');
			console.log('User ID from event:', data.userId);
			console.log('New status:', data.isActive ? 'ONLINE' : 'OFFLINE');

			// ✅ Validate authority - only process if it's for this user
			if (String(data.userId) !== agentId) {
				console.log('Ignoring event for different user:', data.userId);
				return;
			}

			// ✅ Don't update if we're in the middle of toggling
			// This prevents the socket update from overwriting our optimistic update
			if (toggleInProgress.current) {
				console.log('Toggle in progress, skipping socket update');
				return;
			}

			// ✅ Update state and localStorage from server (single source of truth)
			updateUserDetails({ isActive: data.isActive });

			// Show notification based on status change
			if (isMounted.current) {
				message.success(data.isActive
					? 'You are now online and ready to receive leads'
					: 'You are now offline');
			}
		};

		// ✅ Force logout handler using auth context
		const handleForceLogout = (data) => {
			if (!isMounted.current) return;

			console.log('Force logout:', data);
			// Don't show message here, let the logout function handle it
			performLogout(true);
		};

		const handleLeadAssigned = (data) => {
			if (!isMounted.current) return;
			console.log('Lead assigned:', data);
			if (data.lead) {
				setLeads(prev => [data.lead, ...prev]);
			}
		};

		// Store handlers in ref for cleanup
		socketEventHandlersRef.current = {
			accountStatusUpdated: handleAccountStatusUpdated,
			forceLogout: handleForceLogout,
			leadAssigned: handleLeadAssigned
		};

		// ✅ Register for correct events
		socketRef.current.on("account-status-updated", handleAccountStatusUpdated);
		socketRef.current.on("forceLogout", handleForceLogout);
		socketRef.current.on("lead-assigned", handleLeadAssigned);

		return () => {
			if (socketRef.current) {
				socketRef.current.off("account-status-updated", handleAccountStatusUpdated);
				socketRef.current.off("forceLogout", handleForceLogout);
				socketRef.current.off("lead-assigned", handleLeadAssigned);
			}
		};
	}, [userDetails?.id, updateUserDetails]);

	// ✅ FIXED: toggleStatus with immediate UI update and proper error handling
	const toggleStatus = async (checked) => {
		// Prevent multiple simultaneous toggles
		if (toggleInProgress.current || toggleLoading || !isMounted.current) {
			return;
		}

		const userId = userDetails?.id;

		if (!userId) {
			if (isMounted.current) {
				message.error('User information not found. Please refresh the page.');
			}
			return;
		}

		toggleInProgress.current = true;
		setToggleLoading(true);

		// ✅ OPTIMISTIC UPDATE: Update UI and localStorage immediately for better user experience
		const previousStatus = userDetails.isActive;
		updateUserDetails({ isActive: checked });

		try {
			console.log('Toggling status via REST:', { userId, checked });

			const response = await API.ToggleStatus(userId, checked);

			if (!isMounted.current) return;

			if (!response?.status) {
				// ❌ If API fails, revert the optimistic update
				throw new Error(response?.message || "Failed to update status");
			}

			// ✅ Success - show confirmation
			message.success({
				content: checked ? "You are now online" : "You are now offline",
				duration: 2,
			});

		} catch (err) {
			if (!isMounted.current) return;

			console.error("Toggle failed:", err);

			// ❌ Revert the optimistic update on error
			updateUserDetails({ isActive: !checked });

			message.error(err.message || "Failed to update status. Please try again.");
		} finally {
			if (isMounted.current) {
				setToggleLoading(false);
			}
			setTimeout(() => {
				toggleInProgress.current = false;
			}, 500);
		}
	};

	// ✅ FIXED: handleLogout with proper status update and cleanup
	const performLogout = async (skipConfirm = false) => {
		try {
			setToggleLoading(true);

			// Cancel any pending requests
			if (abortControllerRef.current) {
				abortControllerRef.current.abort();
			}

			// Safely disconnect socket first
			if (socketRef.current) {
				// Remove all event listeners
				if (socketEventHandlersRef.current.accountStatusUpdated) {
					socketRef.current.off("account-status-updated", socketEventHandlersRef.current.accountStatusUpdated);
				}
				if (socketEventHandlersRef.current.forceLogout) {
					socketRef.current.off("forceLogout", socketEventHandlersRef.current.forceLogout);
				}
				if (socketEventHandlersRef.current.leadAssigned) {
					socketRef.current.off("lead-assigned", socketEventHandlersRef.current.leadAssigned);
				}
				socketRef.current.off("connect");

				socketRef.current.disconnect();
				socketRef.current = null;
			}

			// Update status to offline before logout (only if we have user ID)
			if (userDetails?.id && isMounted.current) {
				// Call API to update status (don't await to speed up logout)
				API.updateIsActive(userDetails.id, false).catch(err =>
					console.log('Status update on logout failed:', err)
				);
			}

			// End this login on the server (Account Sessions page). Wait at most 1.5s so
			// the request isn't cut off by the page reload; logout goes ahead either way.
			const sessionToken = localStorage.getItem('token');
			if (sessionToken) {
				await Promise.race([
					API.logoutSession(sessionToken).catch(() => null),
					new Promise((resolve) => setTimeout(resolve, 1500)),
				]);
			}

			// Clear all storage
			localStorage.removeItem('token');
			localStorage.removeItem('userData');
			localStorage.removeItem('sidebarFrom');

			// Call logout from auth context
			logout();

			// Navigate to login with replace
			// navigate(ROUTES.LOGIN, { replace: true });
			window.location.href = "/";

			if (isMounted.current && !skipConfirm) {
				message.success('Logged out successfully');
			}
		} catch (error) {
			console.error("Error during logout:", error);

			// Still logout even if API fails
			localStorage.removeItem('token');
			localStorage.removeItem('userData');
			localStorage.removeItem('sidebarFrom');
			logout();
			navigate(ROUTES.LOGIN, { replace: true });
		} finally {
			if (isMounted.current) {
				setToggleLoading(false);
			}
		}
	};

	const handleLogout = () => {
		Modal.confirm({
			title: "Are you sure you want to logout?",
			okText: "Yes",
			cancelText: "No",
			okType: "danger",
			onOk: () => performLogout(false),
		});
	};

	const UserProfileCard = () => (
		<Card bordered style={{ width: 300, paddingTop: 15 }}>
			<div style={{ textAlign: 'center' }}>
				<Avatar
					style={{
						backgroundColor: '#f56a00',
						color: '#fff',
						marginBottom: 16,
						fontSize: 24,
						height: 64,
						width: 64,
					}}
				>
					{userDetails?.userName?.charAt(0)?.toUpperCase() || 'U'}
				</Avatar>
				<h3 style={{ marginBottom: 4 }}>{userDetails?.userName || 'User'}</h3>
				<p style={{ marginBottom: 4, color: '#888' }}>{userDetails?.email}</p>
				<Tag style={{ marginBottom: 4, color: '#888', fontWeight: 'bold' }} color={isActive ? "green" : "red"}>
					{isActive ? 'ONLINE' : 'OFFLINE'} | {userDetails?.role?.toUpperCase() || 'AGENT'}
				</Tag>
				{/* Display only: super admin is set in the database */}
				{userDetails?.role === 'ADMIN' && userDetails?.isSuperAdmin === true && (
					<div style={{ fontSize: 11, marginTop: 2, color: '#d48806', fontWeight: 600 }}>
						<CrownOutlined /> Super Admin
					</div>
				)}
				<div style={{ marginTop: 16 }}>
					<div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8 }}>
						<span>Status:</span>
						<Switch
							size="small"
							checked={isActive}
							onChange={toggleStatus}
							loading={toggleLoading}
							checkedChildren="On"
							unCheckedChildren="Off"
						/>
					</div>
				</div>
				<div>
					<Button
						type="primary"
						danger
						icon={<LogoutOutlined />}
						onClick={handleLogout}
						style={{ marginTop: 16 }}
						loading={toggleLoading}
					>
						Logout
					</Button>
				</div>
			</div>
		</Card>
	);

	if (!initialLoadComplete) {
		return (
			<Layout style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
				<Spin size="large" tip="Loading user data..." />
			</Layout>
		);
	}

	const currentUserRole = userDetails?.role || authUserData?.role || getStoredUserData()?.role;
	const isMarketingUser = currentUserRole === MARKETING_ROLE;

	return (
		<Layout>
			{userDetails?.isActive && !isMarketingUser && <LeadNotification />}
			<Sidebar collapsed={collapsed} setCollapsed={setCollapsed} />
			<Layout>
				<Header
					style={{
						padding: 0,
						background: '#fff',
						display: 'flex',
						justifyContent: 'space-between',
						alignItems: 'center',
					}}
				>
					<Button
						type="text"
						icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
						onClick={() => setCollapsed(!collapsed)}
						style={{
							fontSize: '16px',
							width: 64,
							height: 64,
						}}
					/>
					<div
						style={{
							marginRight: '16px',
							display: 'flex',
							alignItems: 'center',
							gap: '16px',
						}}
					>
						{!isMarketingUser && (
							<Button
								type="primary"
								icon={<BookOutlined />}
								onClick={() => navigate('/notes')}
							>
								Notes
							</Button>
						)}

						{userDetails && userDetails.role !== 'ADMIN' && !isMarketingUser && (
							<Switch
								checked={isActive}
								onChange={toggleStatus}
								loading={toggleLoading}
								checkedChildren="Online"
								unCheckedChildren="Offline"
								style={{
									backgroundColor: isActive ? '#52c41a' : '#ff4d4f',
								}}
							/>
						)}

						<Dropdown
							dropdownRender={() => <UserProfileCard />}
							placement="bottomRight"
							trigger={['click']}
							arrow
						>
							<span>
								<Badge status={isActive ? "success" : "error"} dot>
									<Avatar
										style={{ backgroundColor: '#fde3cf', color: '#f56a00', cursor: 'pointer' }}
									>
										{userDetails?.userName?.charAt(0)?.toUpperCase() || 'U'}
									</Avatar>
								</Badge>
							</span>
						</Dropdown>
					</div>
				</Header>

				<div style={{ position: 'relative', flex: 1, overflow: 'hidden' }}>
					{(!isActive && userDetails?.role !== "ADMIN" && !isMarketingUser) && (
						<div
							style={{
								position: 'absolute',
								inset: 0,
								background: 'rgba(255, 255, 255, 0.7)',
								backdropFilter: 'blur(8px)',
								zIndex: 1000,
								display: 'flex',
								alignItems: 'center',
								justifyContent: 'center',
								pointerEvents: 'auto',
							}}
						>
							<div
								style={{
									background: '#fff',
									padding: '40px 32px',
									borderRadius: '16px',
									maxWidth: '440px',
									width: 'calc(100% - 48px)',
									boxSizing: 'border-box',
									textAlign: 'center',
									boxShadow: '0 12px 40px rgba(0,0,0,0.18)',
								}}
							>
								<div
									style={{
										width: '80px',
										height: '80px',
										borderRadius: '50%',
										background: '#ff4d4f',
										margin: '0 auto 24px',
										display: 'flex',
										alignItems: 'center',
										justifyContent: 'center',
									}}
								>
									<CloseCircleTwoTone style={{ fontSize: '40px', color: '#fff' }} twoToneColor="#fff" />
								</div>

								<div style={{ fontSize: '15px', color: '#666', marginBottom: '12px' }}>
									<span style={{ color: '#ff4d4f', marginRight: '8px', fontSize: '18px' }}>●</span>
									Status: <b>Offline</b>
								</div>

								<h2 style={{ fontSize: '26px', fontWeight: 700, marginBottom: '16px', color: '#1f1f1f' }}>
									You're Currently Offline
								</h2>

								<p style={{ fontSize: '15px', color: '#555', margin: '0 0 32px', lineHeight: 1.5 }}>
									Go online to start receiving new leads and assignments.
								</p>

								<Button
									type="primary"
									size="large"
									icon={<CheckCircleFilled />}
									onClick={() => toggleStatus(true)}
									loading={toggleLoading}
									style={{
										background: '#1677ff',
										border: 'none',
										borderRadius: '10px',
										height: '52px',
										fontSize: '17px',
										fontWeight: 600,
										width: '100%',
									}}
								>
									Go Online
								</Button>
							</div>
						</div>
					)}

					<Content
						style={{
							margin: 0,
							padding: '24px 16px',
							height: 'calc(100vh - 64px)',
							background: '#fff',
							borderRadius: '8px',
							overflowY: 'auto',
							transition: 'filter 0.4s ease',
							filter: (!isActive && userDetails?.role !== "ADMIN" && !isMarketingUser) ? 'blur(3px)' : 'none',
						}}
					>
						<div style={{ minHeight: 'calc(100% - 48px)' }}>
							<TimezoneBanner />
							{isMarketingUser ? (
								<Routes>
									<Route path={ROUTES.MYLEADS} element={<MarketingLeads />} />
									<Route path="*" element={<Navigate to={ROUTES.MYLEADS} replace />} />
								</Routes>
							) : (
							<Routes>
								<Route path={ROUTES.DASHBOARD} element={<Dashboard />} />
								<Route path={ROUTES.TEAM} element={<Team />} />
								<Route
									path={ROUTES.DOMAIN_MAPPING}
									element={
										userDetails?.role === 'ADMIN'
											? <DomainMapping />
											: <Navigate to={ROUTES.TEAM} replace />
									}
								/>
								<Route path={ROUTES.MYFOLLOWUPS} element={<MyFollowUps />} />
								<Route path={ROUTES.MYLEADS} element={<MyLeads />} />
								<Route path={ROUTES.REVIEWLEADS} element={<ReviewLeads />} />
								<Route
									path={ROUTES.ACCOUNT_SESSIONS}
									element={
										userDetails?.role === 'ADMIN'
											? <AccountSessions />
											: <Navigate to={ROUTES.MYLEADS} replace />
									}
								/>
								<Route path="/follow-up-lead/:id" element={<IndividulFollowUpLead />} />
								<Route path="/lead-details/:id" element={<LeadDetails />} />
								<Route path={ROUTES.MAIL} element={<EmailInbox />} />
								<Route path="/zoho-sign" element={<ZohoSign />} />
								<Route path="/zoho-sign-complete" element={<ZohoSignComplete />} />
								<Route path="/paymant-pending/:id" element={<PaymentPending />} />
								<Route path="/notes" element={<NoteList />} />

								<Route path="/queue" element={<QueueDashboard />} />
								<Route path="/leadpage" element={<AllLeadsView />} />
								<Route path="/round-robin" element={<RRVisualizationDashboard />} />
								<Route path={ROUTES.VIEWYARDPAGE} element={<ViewyardDetails />} />
								<Route path="/yard-details/:id" element={<YardDetailsPage />} />
								<Route path={ROUTES.SALEMADE} element={<SaleMadeLead />} />
								<Route path={ROUTES.ISSUETRACKING} element={<IssueTracking />} />
								<Route path={ROUTES.PendingPayment} element={<PendingPayment />} />
								<Route
									path={ROUTES.advancePayment}
									element={canAccessAdvancePayment(currentUserRole) ? <AdvancePayment /> : <Navigate to={ROUTES.MYLEADS} replace />}
								/>
								<Route path={ROUTES.orderPending} element={<OrderPending />} />
								<Route path={ROUTES.ShipmentTracking} element={<ShipmentTracking />} />
								<Route path={ROUTES.ShipmentTrackingComplete} element={<ShipmentTrackingComplete />} />

								<Route path={ROUTES.orderComplete} element={<OrderComplete />} />
																<Route path={ROUTES.ReLocate} element={<ReLocate />} />

								<Route path={ROUTES.Invoice} element={<Invoice key="invoice-pending-alias" invoiceView="pending" />} />
								<Route path={ROUTES.InvoicePending} element={<Invoice key="invoice-pending" invoiceView="pending" />} />
								<Route path={ROUTES.InvoiceCompleted} element={<Invoice key="invoice-completed" invoiceView="completed" />} />
								<Route path={ROUTES.dispute} element={<DisputeLead />} />

      <Route path={ROUTES.YardRefund} element={<YardRefund />} />
      <Route path={ROUTES.CustomerRefund} element={<CustomerRfund />} />
	        <Route path={ROUTES.YardRefundCompleted} element={<YardRefundCompleted />} />
      <Route path={ROUTES.CustomerRefundCompleted} element={<CustomerRfundCompleted />} />
       <Route path="/customer" element={<Customer />} />
       <Route path="/customer-details/:customerId" element={<CustomerDetails />} />
        <Route path={ROUTES.SaleMadeComplete} element={<SaleMadeComplete />} />
               <Route path={ROUTES.CustomerCancel} element={<CustomerCancel />} />
               <Route
                  path={ROUTES.FLOW_DIAGRAM}
                  element={canAccessFlowDiagram(currentUserRole)
                     ? (
                        <React.Suspense fallback={<div style={{ padding: 48, textAlign: 'center' }}><Spin /></div>}>
                           <FlowDiagram />
                        </React.Suspense>
                     )
                     : <Navigate to={ROUTES.MYLEADS} replace />}
               />

                     </Routes>
							)}
                  </div>
               </Content>
            </div>
         </Layout>
      </Layout>
   );
};


const Sidebar = ({ collapsed, setCollapsed }) => {
	const navigate = useNavigate();
	const location = useLocation();
	const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
	const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
	const desktopMenuScrollRef = useRef(null);
	const desktopMenuScrollTopRef = useRef(0);

	useEffect(() => {
		const handleResize = () => {
			const mobile = window.innerWidth <= 768;
			setIsMobile(mobile);
			if (!mobile && mobileMenuOpen) {
				setMobileMenuOpen(false);
			}
		};

		window.addEventListener('resize', handleResize);
		return () => window.removeEventListener('resize', handleResize);
	}, [mobileMenuOpen]);

	useLayoutEffect(() => {
		if (!desktopMenuScrollRef.current) return;

		desktopMenuScrollRef.current.scrollTop = desktopMenuScrollTopRef.current;
	}, [location.pathname]);

	const getSelectedKeys = () => {
		const path = location.pathname;
		const from = location.state?.from || localStorage.getItem('sidebarFrom');

		if (from) {
			localStorage.setItem('sidebarFrom', from);
		}

		if (path.startsWith('/lead-details')) {
			if (from === '/my-follow-ups') return ['/my-follow-ups'];
			if (from === '/sale-made') return ['/sale-made'];
			if (from === '/shipment-tracking') return ['/shipment-tracking'];
			if (from === '/shipment-tracking-complete') return ['/shipment-tracking-complete'];
			if (from === ROUTES.Invoice || from === ROUTES.InvoicePending) return [ROUTES.InvoicePending];
			if (from === ROUTES.InvoiceCompleted) return [ROUTES.InvoiceCompleted];
			return ['/my-leads'];
		}

      if (path.startsWith('/follow-up-lead') || path === '/my-follow-ups') return ['/my-follow-ups'];
      if (path.startsWith('/paymant-pending')) return ['/my-leads'];
      if (path.startsWith('/mail-box')) return ['/mail-box'];
      if (path.startsWith('/dashboard')) return ['/dashboard'];
      if (path.startsWith('/agent')) return ['/agent'];
      if (path.startsWith('/customer-details') || path === '/customer') return ['/customer'];
      if (path.startsWith(ROUTES.REVIEWLEADS)) return [ROUTES.REVIEWLEADS];
      if (path.startsWith(ROUTES.ACCOUNT_SESSIONS)) return [ROUTES.ACCOUNT_SESSIONS];
      if (path.startsWith('/notes')) return ['/notes'];
      if (path.startsWith('/queue')) return ['/queue'];
      if (path.startsWith('/round-robin')) return ['/round-robin'];
      if (path.startsWith('/yard-page')) return ['/yard-page'];
      if (path === ROUTES.Invoice || path === ROUTES.InvoicePending) return [ROUTES.InvoicePending];
      if (path === ROUTES.InvoiceCompleted) return [ROUTES.InvoiceCompleted];

		return [path];
	};

   const userData = getStoredUserData();
   const userRole = userData?.role;
const userEmail = userData?.email?.toLowerCase();
// const order = userEmail === 'orders@premiumusedautoparts.com';
// const part =
//   userEmail === 'parts@premiumusedautoparts.com' ||
//   userEmail === 'support@premiumusedautoparts.com';

   const handleMenuClick = ({ key }) => {
      if (desktopMenuScrollRef.current && !isMobile) {
         desktopMenuScrollTopRef.current = desktopMenuScrollRef.current.scrollTop;
      }

      localStorage.setItem('sidebarFrom', key);
      navigate(key);
      if (isMobile) {
         setMobileMenuOpen(false);
      }
   };

	// Function to truncate long labels
	const truncateLabel = (label, maxLength = 12) => {
		if (!collapsed && !isMobile) return label;
		if (label.length <= maxLength) return label;
		return `${label.substring(0, maxLength)}...`;
	};

   // Menu items with truncation
   const getMenuItems = () => {
      const items = [

         ...(userRole === 'ADMIN'
            ? [
               {
                  key: '/dashboard',
                  icon: <DashboardOutlined />,
                  label: truncateLabel('Dashboard'),
                  title: 'Dashboard', // Full text for tooltip
               },
            ]
            : []),
			     ...(userRole === 'ADMIN'
            ? [
               {
                  key: '/round-robin',
                  icon: <ProjectOutlined />,
                  label: truncateLabel('Round Robin'),
                  title: 'Round Robin',
               },
               {
                  key: '/queue',
                  icon: <SafetyCertificateOutlined />,
                  label: truncateLabel('Queue'),
                  title: 'Queue',
               },
            ]
            : []),
			         {
            key: '/mail-box',
            icon: <MailOutlined />,
            label: truncateLabel('Mail Box'),
            title: 'Mail Box',
         },
        
         
         {
            key: '/my-leads',
            icon: <CrownOutlined />,
            label: truncateLabel(userRole === 'ADMIN' ? 'All Leads' : 'My Leads'),
            title: userRole === 'ADMIN' ? 'All Leads' : 'My Leads',
         },
         ...(userRole === 'ADMIN'
            ? [{
               key: ROUTES.REVIEWLEADS,
               icon: <BugOutlined />,
               label: truncateLabel('Review Leads'),
               title: 'Review Leads',
            }]
            : []),
    

		     ...(userRole !== 'SERVICE-AGENT'  ? [
         {
            key: '/my-follow-ups',
            icon: <AimOutlined />,
            label: truncateLabel(userRole === 'ADMIN' ? 'All Follow Ups' : 'My Follow Ups'),
            title: userRole === 'ADMIN' ? 'All Follow Ups' : 'My Follow Ups',
         },] : []),
		                    ...(canAccessAdvancePayment(userRole) ? [{
 key: '/advance-payment',
            icon: <TransactionOutlined />,
            label: truncateLabel('Advance Payment'),
            title: 'Advance Payment',
}] : []),
    ...(userRole === 'ADMIN' || userRole === 'SERVICE-AGENT' ? [{
 key: '/pending-payment',
            icon: <WalletOutlined />,
            label: truncateLabel('Pending Payment'),
            title: 'Pending Payment',
}] : []),
            ...(userRole === 'ADMIN' || userRole === 'SERVICE-AGENT' ? [{
            key: ROUTES.InvoicePending,
            icon: <FileDoneOutlined />,
            label: truncateLabel('Invoice Pending'),
            title: 'Invoice Pending',
         }] : []),
            ...(userRole === 'ADMIN' || userRole === 'SERVICE-AGENT' ? [{
            key: ROUTES.InvoiceCompleted,
            icon: <FileDoneOutlined />,
            label: truncateLabel('Invoice Completed'),
            title: 'Invoice Completed',
         }] : []),
             ...(userRole === 'ADMIN' || userRole === 'SERVICE-AGENT' ? [{
 key: '/order-pending',
            icon: <ShoppingCartOutlined />,
            label: truncateLabel('Order Process'),
            title: 'Order Process',
}] : []),
  
    ...(userRole === 'ADMIN' || userRole === 'SERVICE-AGENT' ? [{
   key: '/zoho-sign',
   icon: <SignatureOutlined />,
   label: truncateLabel('Zoho Sign Pending'),
   title: 'Zoho Sign Pending',
}] : []),
    ...(userRole === 'ADMIN' || userRole === 'SERVICE-AGENT' ? [{
   key: '/zoho-sign-complete',
   icon: <SignatureOutlined />,
   label: truncateLabel('Zoho Sign Complete'),
   title: 'Zoho Sign Complete',
}] : []),
  ...(userRole === 'ADMIN' || userRole === 'SERVICE-AGENT' ? [{
                  key: '/yard-page',
                  icon: <ShopOutlined />,
                  label: truncateLabel('Yard Details'),
                  title: 'Yard Details',
               },
            ]
            : []
         ),


       
                     ...(userRole === 'ADMIN' || userRole === 'SERVICE-AGENT' ? [{
   key: '/shipment-tracking',
            icon: <CarOutlined />,
            label: truncateLabel('Shipment Tracking Pending'),
            title: 'Shipment Tracking Pending',
}] : []),
                     ...(userRole === 'ADMIN' || userRole === 'SERVICE-AGENT' ? [{
   key: '/shipment-tracking-complete',
            icon: <CarOutlined />,
            label: truncateLabel('Delivery Tracking'),
            title: 'Delivery Tracking',
}] : []),
             {
            key: '/order-complete',
            icon: <ShoppingBag />,
            label: truncateLabel('Order Complete'),
            title: 'Order Complete',
         },
   {
            key: '/re-locate',
            icon: <ReloadOutlined />,
            label: truncateLabel('ReLocate'),
            title: 'ReLocate',
         },

		
		   {
            key: '/sale-made',
            icon: <ShoppingCartOutlined />,
            label: truncateLabel('Sale Made'),
            title: 'Sale Made',
         },
            {
            key: '/Sale-made-complete',
            icon: <ShoppingBasket />,
            label: truncateLabel('Sale Made Complete'),
            title: 'Sale Made Complete',
         },

{
  key: '/yard-refund',
  icon: <Undo2 />,
  label: truncateLabel('Yard Refund'),
  title: 'Yard Refund',
},
{
  key: '/yard-refund-completed',
  icon: <Undo2 />,
  label: truncateLabel('Yard Refund Completed'),
  title: 'Yard Refund Completed',
},

{
  key: '/customer-refund',
  icon: <BadgeDollarSign />,
  label: truncateLabel('Customer Refund'),
  title: 'Customer Refund',
},
{
  key: '/customer-refund-completed',
  icon: <BadgeDollarSign />,
  label: truncateLabel('Customer Refund Completed'),
  title: 'Customer Refund Completed',
},
       
         {
            key: '/issue-tracking',
            icon: <ToolOutlined />,
            label: truncateLabel('Issue Tracking'),
            title: 'Issue Tracking',
         },
		 {
            key: '/dispute-lead',
            icon: <ExclamationCircleOutlined />,
            label: truncateLabel('Dispute'),
            title: 'Dispute',
         },
	 {
            key: '/customer-cancel',
            icon: <CircleX />,
            label: truncateLabel('Customer Cancel'),
            title: 'Customer Cancel',
         },

		 
         {
            key: '/agent',
            icon: <TeamOutlined />,
            label: truncateLabel('Team'),
            title: 'Team',
         },
         ...(userRole === 'ADMIN'
            ? [
               {
                  key: '/domain-mapping',
                  icon: <ApartmentOutlined />,
                  label: truncateLabel('Domain Mapping'),
                  title: 'Domain Mapping',
               },
            ]
            : []),
         {
            key: '/customer',
            icon: <SafetyCertificateOutlined />,
            label: truncateLabel('Customer'),
            title: 'Customer',
         },
         ...(canAccessFlowDiagram(userRole) ? [{
            key: ROUTES.FLOW_DIAGRAM,
            icon: <PartitionOutlined />,
            label: truncateLabel('Flow Diagram'),
            title: 'Flow Diagram',
         }] : []),
         ...(userRole === 'ADMIN'
            ? [{
               key: ROUTES.ACCOUNT_SESSIONS,
               icon: <LaptopOutlined />,
               label: truncateLabel('Account Sessions'),
               title: 'Account Sessions',
            }]
            : []),
      ];

		// Add tooltips for truncated items in collapsed mode
		const visibleItems = userRole === MARKETING_ROLE
			? items.filter(item => MARKETING_MENU_KEYS.includes(item.key))
			: items;

		return visibleItems.map(item => ({
			...item,
			...(collapsed && {
				label: (
					<Tooltip title={item.title} placement="right">
						<span>{item.label}</span>
					</Tooltip>
				)
			})
		}));
	};

	const MobileToggleButton = () => (
		<Button
			type="primary"
			icon={mobileMenuOpen ? <CloseOutlined /> : <MenuUnfoldOutlined />}
			onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
			style={{
				position: 'fixed',
				top: 16,
				left: 16,
				zIndex: 1000,
				display: isMobile ? 'block' : 'none',
			}}
		/>
	);

	// Desktop sidebar
	const DesktopSidebar = () => (
		<Sider
			trigger={null}
			collapsible
			collapsed={collapsed}
			onCollapse={setCollapsed}
			width={220} // Fixed width for expanded state
			collapsedWidth={80} // Width when collapsed
			style={{
				height: '100vh',
				overflow: 'hidden',
				position: 'sticky',
				top: 0,
				left: 0,
				display: isMobile ? 'none' : 'block',
			}}
		>
			<div className="sidebar-header" style={{
				height: 32,
				margin: '16px',
				overflow: 'hidden',
				whiteSpace: 'nowrap'
			}}>
				<p className={`text-white fs-5 ${collapsed ? 'text-center' : ''}`}
					style={{ margin: 0, overflow: 'hidden', textOverflow: 'ellipsis' }}>
					{collapsed ? 'APC' : 'Autopulse CRM'}
				</p>
			</div>

			<div
				ref={desktopMenuScrollRef}
				style={{
					overflowY: 'auto',
					overflowX: 'hidden',
					height: 'calc(100vh - 180px)'
				}}
			>
				<Menu
					theme="dark"
					mode="inline"
					selectedKeys={getSelectedKeys()}
					onClick={handleMenuClick}
					items={getMenuItems()}
					style={{
						border: 'none'
					}}
				/>
			</div>

			{!collapsed && (
				<div
					style={{
						color: '#ccc',
						padding: '12px',
						fontSize: 11,
						textAlign: 'left',
						borderTop: '1px solid #333',
						position: 'absolute',
						bottom: 0,
						width: '100%',
						background: '#001529',
						boxSizing: 'border-box'
					}}
				>
					<div style={{ marginBottom: 6, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
						&copy; {new Date().getFullYear()} Auto Pulse CRM
					</div>
					<div style={{ marginBottom: 4, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
						<a href="mailto:admin@autopulsecrm.com" style={{ color: '#ccc' }}>
							admin@autopulsecrm.com
						</a>
					</div>
					<div style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
						<a
							href="https://candelainnovations.in/"
							target="_blank"
							rel="noopener noreferrer"
							style={{ color: '#ccc' }}
						>
							https://candelainnovations.in/
						</a>
					</div>
				</div>
			)}
		</Sider>
	);

	// Mobile drawer menu
	const MobileDrawer = () => (
		<Drawer
			placement="left"
			closable={false}
			onClose={() => setMobileMenuOpen(false)}
			open={mobileMenuOpen}
			width={280}
			bodyStyle={{ padding: 0, background: '#001529' }}
			headerStyle={{ display: 'none' }}
		>
			<div style={{
				padding: '16px',
				color: '#fff',
				borderBottom: '1px solid #333'
			}}>
				<h3 style={{ color: '#fff', margin: 0 }}>Autopulse CRM</h3>
			</div>

			<Menu
				theme="dark"
				mode="inline"
				selectedKeys={getSelectedKeys()}
				onClick={handleMenuClick}
				items={(userRole === MARKETING_ROLE
					? menuItems.filter(item => MARKETING_MENU_KEYS.includes(item.key))
					: menuItems
				).map(item => ({
					...item,
					label: item.title || item.label // Use full text in mobile drawer
				}))}
				style={{
					border: 'none',
					height: 'calc(100vh - 180px)',
					overflowY: 'auto'
				}}
			/>

			<div
				style={{
					color: '#ccc',
					padding: '16px',
					fontSize: 12,
					textAlign: 'left',
					borderTop: '1px solid #333',
					position: 'absolute',
					bottom: 0,
					width: '100%',
					background: '#001529',
				}}
			>
				<div style={{ marginBottom: 8 }}>
					&copy; {new Date().getFullYear()} Auto Pulse CRM
				</div>
				<div style={{ marginBottom: 4 }}>
					<a href="mailto:admin@autopulsecrm.com" style={{ color: '#ccc' }}>
						admin@autopulsecrm.com
					</a>
				</div>
				<div>
					<a
						href="https://candelainnovations.in/"
						target="_blank"
						rel="noopener noreferrer"
						style={{ color: '#ccc' }}
					>
						website
					</a>
				</div>
			</div>
		</Drawer>
	);

   // Full menu items for mobile (without truncation)
   const menuItems = [
      ...(userRole === 'ADMIN'
         ? [
            {
               key: '/dashboard',
               icon: <DashboardOutlined />,
               label: 'Dashboard',
            },
         ]
         : []),
      {
         key: '/my-leads',
         icon: <CrownOutlined />,
         label: userRole === 'ADMIN' ? 'All Leads' : 'My Leads',
      },
      ...(userRole === 'ADMIN'
         ? [{
            key: ROUTES.REVIEWLEADS,
            icon: <BugOutlined />,
            label: 'Review Leads',
            title: 'Review Leads',
         }]
         : []),
      ...(userRole === 'ADMIN'
         ? [
            {
               key: '/round-robin',
               icon: <ProjectOutlined />,
               label: "Round Robin"
            },
            {
               key: '/queue',
               icon: <SafetyCertificateOutlined />,
               label: "Queue"
            },
         ]
         : []),
   
		     ...(userRole !== 'SERVICE-AGENT'  ? [
         {
            key: '/my-follow-ups',
            icon: <AimOutlined />,
            label: truncateLabel(userRole === 'ADMIN' ? 'All Follow Ups' : 'My Follow Ups'),
            title: userRole === 'ADMIN' ? 'All Follow Ups' : 'My Follow Ups',
         },] : []),
          ...(userRole === 'ADMIN' || userRole === 'SERVICE-AGENT' ? [{
   key: '/zoho-sign',
   icon: <SignatureOutlined />,
   label: truncateLabel('Zoho Sign Pending'),
   title: 'Zoho Sign Pending',
}] : []),
    ...(userRole === 'ADMIN' || userRole === 'SERVICE-AGENT' ? [{
   key: '/zoho-sign-complete',
   icon: <SignatureOutlined />,
   label: truncateLabel('Zoho Sign Complete'),
   title: 'Zoho Sign Complete',
}] : []),
      {
         key: '/mail-box',
         icon: <MailOutlined />,
         label: 'Mail Box',
      },
      ...(userRole  === 'ADMIN' || userRole === 'SERVICE-AGENT' 
         ? [
            {
               key: '/yard-page',
               icon: <ShopOutlined />,
               label: 'Yard Details',
            },
         ]
         : []
      ),
            ...(userRole === 'ADMIN' || userRole === 'SERVICE-AGENT' ? [{
 key: '/pending-payment',
            icon: <WalletOutlined />,
            label: truncateLabel('Pending Payment'),
            title: 'Pending Payment',
}] : []),
                    ...(userRole === 'ADMIN' || userRole === 'SERVICE-AGENT' ? [{
  key: ROUTES.InvoicePending,
            icon: <FileDoneOutlined />,
            label: truncateLabel('Invoice Pending'),
            title: 'Invoice Pending',
}] : []),
                    ...(userRole === 'ADMIN' || userRole === 'SERVICE-AGENT' ? [{
  key: ROUTES.InvoiceCompleted,
            icon: <FileDoneOutlined />,
            label: truncateLabel('Invoice Completed'),
            title: 'Invoice Completed',
}] : []),
                   ...(canAccessAdvancePayment(userRole) ? [{
 key: '/advance-payment',
            icon: <TransactionOutlined />,
            label: truncateLabel('Advance Payment'),
            title: 'Advance Payment',
}] : []),
                 ...(userRole === 'ADMIN' || userRole === 'SERVICE-AGENT' ? [{
  key: '/order-pending',
            icon: <ShoppingCartOutlined />,
            label: truncateLabel('Order Process'),
            title: 'Order Process',
}] : []),
                     ...(userRole === 'ADMIN' || userRole === 'SERVICE-AGENT' ? [{
   key: '/shipment-tracking',
            icon: <CarOutlined />,
            label: truncateLabel('Shipment Tracking Pending'),
            title: 'Shipment Tracking Pending',
}] : []),
                     ...(userRole === 'ADMIN' || userRole === 'SERVICE-AGENT' ? [{
   key: '/shipment-tracking-complete',
            icon: <CarOutlined />,
            label: truncateLabel('Delivery Tracking'),
            title: 'Delivery Tracking',
}] : []),
 
      {
            key: '/order-complete',
            icon: <ShoppingBag />,
            label: truncateLabel('Order Complete'),
            title: 'Order Complete',
         },
		    {
            key: '/re-locate',
            icon: <ReloadOutlined />,
            label: truncateLabel('ReLocate'),
            title: 'ReLocate',
         },
         {
  key: '/yard-refund',
  icon: <Undo2 />,
  label: truncateLabel('Yard Refund'),
  title: 'Yard Refund',
},
{
  key: '/yard-refund-completed',
  icon: <Undo2 />,
  label: truncateLabel('Yard Refund Completed'),
  title: 'Yard Refund Completed',
},

{
  key: '/customer-refund',
  icon: <BadgeDollarSign />,
  label: truncateLabel('Customer Refund'),
  title: 'Customer Refund',
},
{
  key: '/customer-refund-completed',
  icon: <BadgeDollarSign />,
  label: truncateLabel('Customer Refund Completed'),
  title: 'Customer Refund Completed',
},
      {
         key: '/sale-made',
         icon: <ShoppingCartOutlined />,
         label: 'Sale Made',
      },
      {
         key: '/issue-tracking',
         icon: <ToolOutlined />,
         label: 'Issue Tracking',
      },
	  	 {
            key: '/dispute-lead',
            icon: <ExclamationCircleOutlined />,
            label: truncateLabel('Dispute'),
            title: 'Dispute',
         },
		  {
            key: '/customer-cancel',
            icon: <CircleX />,
            label: truncateLabel('Customer Cancel'),
            title: 'Customer Cancel',
         },
      {
         key: '/agent',
         icon: <TeamOutlined />,
         label: 'Team',
      },
      ...(userRole === 'ADMIN'
         ? [
            {
               key: '/domain-mapping',
               icon: <ApartmentOutlined />,
               label: 'Domain Mapping',
            },
         ]
         : []),
      {
         key: '/customer',
         icon: <SafetyCertificateOutlined />,
         label: 'Customer',
      },
      ...(canAccessFlowDiagram(userRole) ? [{
         key: ROUTES.FLOW_DIAGRAM,
         icon: <PartitionOutlined />,
         label: 'Flow Diagram',
      }] : []),
      ...(userRole === 'ADMIN'
         ? [{
            key: ROUTES.ACCOUNT_SESSIONS,
            icon: <LaptopOutlined />,
            label: 'Account Sessions',
            title: 'Account Sessions',
         }]
         : []),
   ];

	return (
		<>
			<MobileToggleButton />
			<DesktopSidebar />
			<MobileDrawer />
		</>
	);
};



export default App;
